// extracted by mini-css-extract-plugin
export default {"departments":"lM-z","departmentHeading":"mM-z","departmentSection":"nM-z","departmentName":"oM-z","departmentLink":"pM-z","expandIcon":"qM-z"};